module.exports = __webpack_public_path__ + "static/video_1-d2d3adcb1bdeafd23ad7eed2215ff859.png";